(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {

  const form = document.getElementById('signup-form');
  const phoneInput = document.getElementById('phone');

  if (!form || !phoneInput) return;

  // Auto format
  phoneInput.addEventListener('input', function(e) {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 4) {
      value = value.slice(0,4) + ' ' + value.slice(4,8);
    }
    e.target.value = value;
  });

  // Submit
  form.addEventListener('submit', async function(e) {
    e.preventDefault();

    const firstName = document.getElementById('first_name').value;
    const lastName = document.getElementById('last_name').value;
    const phoneRaw = phoneInput.value.replace(/\D/g, '');

    if (!/^[569]\d{7}$/.test(phoneRaw)) {
      alert('Enter valid Kuwait number');
      return;
    }

    const phone = '+965' + phoneRaw;

    try {
      const response = await fetch('https://a.klaviyo.com/api/profiles/', {
        method: 'POST',
        headers: {
          'Authorization': 'Klaviyo-API-Key pk_RBj5ck_18f1e964153c265012f5b221eb39c6ffe3',
          'Content-Type': 'application/json',
          'revision': '2023-10-15'
        },
        body: JSON.stringify({
          data: {
            type: "profile",
            attributes: {
              first_name: firstName,
              last_name: lastName,
              phone_number: phone
            }
          }
        })
      });

      const result = await response.json();

      console.log("STATUS:", response.status);
      console.log("RESULT:", result);

      if (response.status === 200 || response.status === 201) {
        form.innerHTML = "<h3>You're in 🎉</h3>";
      } else {
        alert('API error');
      }

    } catch (error) {
      console.error("ERROR:", error);
      alert('Something went wrong');
    }

  });

});


  } catch(e) { console.error(e); }
})();
})();
